import logo_dark from '../../assets/ywt_logo_dark.svg';
import logo_light from '../../assets/ywt_logo_light.svg';
import logo_with_text_dark from '../../assets/ywt_logo_with_text_dark.svg';
import logo_with_text_light from '../../assets/ywt_logo_with_text_light.svg';
import { Link } from 'react-router';
import { ROUTES } from '../../routes';
import { ChevronDown, Mail } from 'lucide-react';
import reddit from '../../assets/reddit.svg';
import discord from '../../assets/discord.svg';
import swiss from '../../assets/swiss.svg';
import { StatusChecker } from './StatusChecker';
import { YWT_PUBLIC_CONFIG } from '@cuspar/ywt.ch.config/public';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@cuspar/ui';
import { useTranslation } from 'react-i18next';
import { clarityEnabled } from '../../analytics/clarity';
import { usePreferencesStore } from '../../state/preferencesStore';

export const Footer = () => {
  const { t } = useTranslation();
  const setAnalyticsConsent = usePreferencesStore((s) => s.setAnalyticsConsent);
  return (
    <header className='font-mono w-full h-full border-t border-border/40 bg-background/95 p-3 flex flex-col lg:flex-row'>
      <p className='flex items-center gap-1 text-xs justify-center w-full'>
        <img src={logo_with_text_dark} alt='YourWebTech (ywt.ch)' className='h-4 hidden dark:block md:mr-1' />
        <img src={logo_with_text_light} alt='YourWebTech (ywt.ch)' className='h-4 dark:hidden md:mr-1' />
        <span className='hidden lg:block'>{t('footer.productOf', { year: new Date().getFullYear() })}</span>
      </p>
      <div className='container flex max-w-screen-2xl items-center gap-6 md:h-16 h-10 justify-center'>
        <div className='mr-4 hidden md:flex cursor-pointer items-center gap-2'>
          <img src={logo_dark} alt='YourWebTech (ywt.ch)' className='h-4 hidden dark:block' />
          <img src={logo_light} alt='YourWebTech (ywt.ch)' className='h-4 dark:hidden' />
          <StatusChecker />
        </div>
        <DropdownMenu>
          <DropdownMenuTrigger className='text-xs md:text-sm cursor-pointer hover:text-primary/60 flex items-center gap-1'>
            {t('nav.legal')} <ChevronDown className='h-3 w-3' />
          </DropdownMenuTrigger>
          <DropdownMenuContent side='top'>
            <DropdownMenuItem asChild>
              <Link to={ROUTES.legal.terms}>{t('nav.termsOfService')}</Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to={ROUTES.legal.dra}>{t('nav.domainRegistrationAgreement')}</Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to={ROUTES.legal.websiteHostingAgreement}>{t('nav.websiteHostingAgreement')}</Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to={ROUTES.legal.dpa}>{t('nav.dataProcessingAgreement')}</Link>
            </DropdownMenuItem>
            <DropdownMenuItem asChild>
              <Link to={ROUTES.legal.privacyPolicy}>{t('nav.privacyPolicy')}</Link>
            </DropdownMenuItem>
            {clarityEnabled && <DropdownMenuItem onSelect={() => setAnalyticsConsent(null)}>{t('consent.settings')}</DropdownMenuItem>}
          </DropdownMenuContent>
        </DropdownMenu>
        <a className='text-xs md:text-sm cursor-pointer hover:text-primary/60' href={YWT_PUBLIC_CONFIG.docsUrl}>
          {t('nav.docs')}
        </a>
      </div>
      <div className='flex items-center justify-center w-full color-grey-900 text-xs font-light gap-1 flex-col lg:flex-row lg:gap-4'>
        <div className='gap-2 flex items-center'>
          <a className='sr-only' title='Reddit' href='https://www.reddit.com/r/ywt/' target='_blank' rel='noopener noreferrer'>
            <img src={reddit} alt='Reddit' className='w-5 h-5 grayscale hover:grayscale-0' />
          </a>
          <a className='sr-only' title='Discord' href='https://discord.gg/a9mAfJGSwx' target='_blank' rel='noopener noreferrer'>
            <img src={discord} alt='Discord' className='w-5 h-5 grayscale hover:grayscale-0' />
          </a>
          <div className='hidden 2xl:flex items-center gap-2 ml-2'>
            <img src={swiss} alt='Swiss' className='w-4 h-4' />
            <p className='text-xs'>{t('footer.swissMadeSoftware')}</p>
          </div>
          <div className='flex gap-2 ml-2'>
            <Mail className='w-4 h-4' />
            <p>support@ywt.ch</p>
          </div>
        </div>
        <p className='text-foreground/40'>v: {YWT_PUBLIC_CONFIG.version.version}</p>
      </div>
    </header>
  );
};
